import type { ForgotPasswordFormData } from "./store/types";
import { parsePhoneNumberFromString } from "libphonenumber-js";

type ValidationErrors = Partial<Record<keyof ForgotPasswordFormData, string>>;

export const validateForgotPasswordForm = (
  formData: ForgotPasswordFormData
): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate phone
  if (!formData.phone) {
    errors.phone = "Phone number is required";
  } else {
    const phoneNumber = parsePhoneNumberFromString(formData.phone);
    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Please enter a valid phone number";
    }
  }

  return errors;
};
